"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelMyPlacesTodayPlansResponseDto = exports.CancelledVenueVisitPlanDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class CancelledVenueVisitPlanDto {}
exports.CancelledVenueVisitPlanDto = CancelledVenueVisitPlanDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CancelledVenueVisitPlanDto.prototype, "planPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CancelledVenueVisitPlanDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueVisitPlanTimeSlot
}), __metadata("design:type", String)], CancelledVenueVisitPlanDto.prototype, "timeSlot", void 0);
class CancelMyPlacesTodayPlansResponseDto {}
exports.CancelMyPlacesTodayPlansResponseDto = CancelMyPlacesTodayPlansResponseDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: () => [CancelledVenueVisitPlanDto]
}), __metadata("design:type", Array)], CancelMyPlacesTodayPlansResponseDto.prototype, "cancelled", void 0);
//# sourceMappingURL=CancelMyPlacesTodayPlansResponse.dto.js.map